import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import ImpactHero from "../components/Impact/ImpactHero";

const articles = [
  {
    id: 1,
    date: "10-3-2025",
    title:
      '"We educate women because it is smart. We educate women because it changes the world." Drew Faust.',
    summary:
      "Momoi's journey exemplifies the mission of the Maasai Girls Rescue Center, where she and over 70 other Maasai girls have found a nurturing environment that empowers them through quality education...",
    videoId: "F0rWdvJxtEg",
  },
  {
    id: 2,
    date: "10-3-2025",
    title: "Maasai Girls Rescue Center - Tanzania",
    summary:
      "As we continue to mark International Women's Day, we celebrate the resilience and potential of Maasai girls through the inspiring story of Momoi Daniely, a resident at the Maasai Girls Rescue Center in Tanzania.",
    videoId: "Fh5GENKLGaM",
  },
  {
    id: 3,
    date: "14-1-2026",
    title: "THE FUTURE IS HERS – Sylvia’s Story | Kisii, Kenya",
    summary:
      "Healthcare does more than heal bodies, it restores dignity, unlocks potential, and keeps hope alive. For Sylvia, a young girl from Kisii, Kenya, access to quality healthcare made all the difference.",
    videoId: "9X-C8kK68EM?si=hjkNHc_o2es_2Efk",
  }
];

const Impact = () => {
  return (
    <div className="">
      <ImpactHero />
      <div className="container my-5">
        <div className="row">
          {/* <h2 className="text-center mb-4">About Our Films</h2> */}
          {articles.map((article) => (
            <div key={article.id} className="col-md-4">
              <div className="card shadow-sm mb-4">
                {/* Responsive Video */}
                <div className="embed-responsive embed-responsive-16by9">
                  <iframe
                    className="embed-responsive-item w-100"
                    src={`https://www.youtube.com/embed/${article.videoId}`}
                    allowFullScreen
                    title={article.title}
                  ></iframe>
                </div>

                {/* Card Content */}
                <div className="card-body">
                  <p className="text-muted">{article.date}</p>
                  <h5 className="card-title">{article.title}</h5>
                  <p className="card-text">{article.summary}</p>
                  <a href={`/impact/${article.id}`} className="read-more text-decoration-none">
                    Read More
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Impact;
